import { useState, useEffect, useCallback } from "react";
import axiosInstance from "../../../api/Axios";

export default function useSelectOptions({
  baseURL,
  initialPage = 1,
  pageSize = 10,
  load,
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(initialPage);
  const [search, setSearch] = useState("");
  const [hasMore, setHasMore] = useState(true);

  const fetchOptions = useCallback(
    async (searchValue = "", pageNum = initialPage) => {
      setLoading(true);
      try {
        const params = {
          page: pageNum,
          page_size: pageSize,
          status: "True",
        };

        if (searchValue?.trim()) {
          params.search = searchValue.trim();
        }

        const res = await axiosInstance.get(baseURL, { params });
        const data = res.data?.results || [];

        setOptions((prev) => {
          if (pageNum === 1) {
            // ✅ fresh load: either initial or search
            return [...data];
          } else {
            // ✅ pagination: append only new unique items
            const merged = [...prev];
            data.forEach((opt) => {
              if (!merged.some((d) => d.id === opt.id)) {
                merged.push(opt);
              }
            });
            return merged;
          }
        });

        setHasMore(!!res.data?.next);
      } catch (err) {
        console.error("Error fetching options:", err);
      } finally {
        setLoading(false);
      }
    },
    [baseURL, pageSize, initialPage]
  );

  useEffect(() => {
    if (load) {
      fetchOptions(search, page);
    }
  }, [search, page, fetchOptions, load]);

  return {
    options,
    loading,
    hasMore,
    setSearch,
    setPage,
    setOptions,
    refresh: () => fetchOptions(search, 1),
  };
}
